import { graphql } from "react-relay";

export const UpdatePolicyCollectionMutation = graphql`
  mutation UpdatePolicyCollectionMutation(
    $input: UpdatePolicyCollectionInput!
  ) {
    updatePolicyCollection(input: $input) {
      collection {
        autoUpdate
        description
        id
        name
        policyMappings {
          edges {
            node {
              policy {
                name
                uuid
                version
              }
            }
          }
        }
        uuid
      }
    }
  }
`;
